import type { ReactNode, Ref } from "react";

export type BuilderStudioShellProps = {
  canvas: ReactNode;
  className?: string;
  documentGuard?: string;
  feedback?: ReactNode;
  floatingLayer?: ReactNode;
  inspector?: ReactNode;
  interactionEngine?: string;
  mainAriaLabel?: string;
  portalLayer?: ReactNode;
  rootRef?: Ref<HTMLDivElement>;
  topbar: ReactNode;
};

export function BuilderStudioShell({
  canvas,
  className = "",
  documentGuard,
  feedback,
  floatingLayer,
  inspector,
  interactionEngine,
  mainAriaLabel,
  portalLayer,
  rootRef,
  topbar,
}: BuilderStudioShellProps) {
  return (
    <div
      ref={rootRef}
      className={[
        "app-frame-viewport z-[70] flex flex-col overflow-hidden bg-bg text-text",
        className,
      ].filter(Boolean).join(" ")}
      data-builder-document-guard={documentGuard}
      data-builder-interaction-engine={interactionEngine}
      data-builder-studio="true"
    >
      {topbar}
      <div className="relative min-h-0 flex-1">
        <main
          className="h-full min-h-0 overflow-hidden"
          aria-label={mainAriaLabel}
          data-builder-studio-main="true"
        >
          {canvas}
        </main>
        {feedback ? (
          <div
            className="pointer-events-none absolute left-4 top-4 z-[90] w-[min(420px,calc(100%-2rem))]"
            data-builder-studio-feedback="true"
          >
            {feedback}
          </div>
        ) : null}
        {inspector}
        {floatingLayer ? (
          <div
            className="pointer-events-none absolute inset-0 z-[100]"
            data-builder-studio-floating-layer="true"
          >
            {floatingLayer}
          </div>
        ) : null}
      </div>
      {portalLayer}
    </div>
  );
}
